export const FETCH_DICTIONARY_START = "FETCH_DICTIONARY_START";
export const FETCH_DICTIONARY_END = "FETCH_DICTIONARY_END";
